import { useState } from 'react'
import Icon, { Icon20 } from 'builder/components/Icon'
import ActionMenu from 'builder/components/ActionMenu'
import { TooltipV2 } from 'builder/components/Tooltip'
import { useI18n } from 'builder/hooks/useI18n'
import { MouseClickEvent } from 'builder/modules/ui'
import {
  Tooltip,
  Header,
  HeaderInner,
  HeaderContent,
  HeaderTitle,
  HeaderSubtitle,
  ToggleIcon,
  ToggleIconInner,
  DeleteIcon,
  DragIcon,
  MobileIcon,
} from './styles'

type Props = {
  title?: string
  subtitle?: string
  onToggle: (event?: MouseClickEvent) => void
  onDelete: (event?: MouseClickEvent) => void
  isOpen?: boolean
  isDragging?: boolean
  disableMove?: boolean
  // eslint-disable-next-line @typescript-eslint/ban-types
  dragHandleListeners?: Record<string, Function>
  isDeleteVisible?: boolean
}

export const CardTitle = (props: Props) => {
  const {
    title,
    subtitle = '',
    isOpen,
    isDragging,
    onToggle,
    onDelete,
    disableMove = false,
    dragHandleListeners,
    isDeleteVisible = false,
  } = props
  const { i18n } = useI18n()
  const [isSheetOpen, setIsSheetOpen] = useState(false)

  const actionSheetOptions = [
    {
      icon: <Icon.Edit />,
      text: i18n.t('builder.resume_editor.edit'),
      onClick: onToggle,
    },
    {
      icon: <Icon.Trash />,
      text: i18n.t('builder.resume_editor.delete'),
      onClick: onDelete,
    },
  ]

  const handleActionSheetOpen = (event: MouseClickEvent) => {
    setIsSheetOpen(true)
    event.stopPropagation()
  }

  const handleActionSheetClose = () => {
    setIsSheetOpen(false)
  }

  return (
    <Header>
      <HeaderInner onClick={onToggle}>
        <HeaderContent>
          <HeaderTitle active={!!isOpen}>{title}</HeaderTitle>
          {subtitle && <HeaderSubtitle>{subtitle}</HeaderSubtitle>}
        </HeaderContent>

        <MobileIcon onClick={handleActionSheetOpen}>
          <Icon.More />
        </MobileIcon>

        <ToggleIcon>
          <Tooltip>
            {isOpen
              ? i18n.t('builder.resume_editor.collapse')
              : i18n.t('builder.resume_editor.expand')}
          </Tooltip>
          <ToggleIconInner isOpen={isOpen}>
            <Icon.ToggleArrow />
          </ToggleIconInner>
        </ToggleIcon>
      </HeaderInner>

      {!disableMove && <DragIcon isDragging={isDragging} {...dragHandleListeners} />}

      <TooltipV2 value={i18n.t('builder.resume_editor.delete')} position="top">
        <DeleteIcon onClick={onDelete} isDeleteVisible={isDeleteVisible}>
          <Icon20.Trash />
        </DeleteIcon>
      </TooltipV2>

      {isSheetOpen && <ActionMenu onClose={handleActionSheetClose} actions={actionSheetOptions} />}
    </Header>
  )
}
